/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useEffect, useMemo } from 'react';
import {
  List, Card, Skeleton, Result, Tag, Divider
} from 'antd';
import 'antd/dist/reset.css';
import { useCalendarApp, ScheduleXCalendar } from '@schedule-x/react';
import { createEventsServicePlugin } from '@schedule-x/events-service';
import {
  createViewMonthAgenda, createViewMonthGrid
} from '@schedule-x/calendar';
import dayjs from 'dayjs';
import useFetchData from '../../hooks/useFetchData';
import { calendars } from '../../utils/calendars';

import '@schedule-x/theme-default/dist/index.css';
import '@schedule-x/theme-shadcn/dist/index.css';
import { formatEvents } from '../../utils/format';
// import { formatEvents } from '../../utils/format';

require('dayjs/locale/fr');

dayjs.locale('fr');

const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

function UserData({ id }) {
  const [loading, error, response] = useFetchData(`/contribution/${id}`);
  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState(today);
  const [activeYears, setActiveYears] = useState([today.year()]);

  const contributions = response?.data?.data || [];
  const stats = response?.data?.stats || [];
  const globalStats = stats?.[0]?.global?.[0] || { totalAmount: 0, totalCount: 0 };
  const statsByYear = stats?.[0]?.byYear || [];
  const attendance = response?.data?.attendance || [];

  const eventsService = useMemo(() => createEventsServicePlugin(), []);

  const yearsFromResponse = useMemo(() => {
    const yearsSet = new Set(
      contributions.map((c) => c.year) // toutes les années présentes
    );
    return Array.from(yearsSet).sort((a, b) => a - b); // trier croissant
  }, [contributions]);

  useEffect(() => {
    console.log('attendance::: ', attendance);

    if (attendance) {
      const formattedEvents = formatEvents(attendance);
      console.log('formattedEvents::: ', formattedEvents);
      formattedEvents.forEach((event) => {
        const events = eventsService.getAll();
        const eventExists = events.some((existingEvent) => existingEvent.id === event.id);
        if (!eventExists) eventsService.add(event);
      });
    }
  }, [attendance, eventsService]);

  const toggleYear = (year) => {
    setActiveYears((prev) => (prev.includes(year) ? prev.filter((y) => y !== year) : [...prev, year]));
  };

  const calendar = useCalendarApp({
    views: [createViewMonthGrid(), createViewMonthAgenda()],
    locale: 'fr-FR',
    calendars,
    dayBoundaries: { start: '04:00', end: '20:00' },
    plugins: [eventsService]
  });

  return (
    <div className='flex flex-col md:flex-row h-screen p-4 gap-4 select-none'>
      <Skeleton loading={loading} active>
        {error ? (
          <Result title='Erreur de chargement' subTitle={error} status='error' />
        ) : (
          <div className='flex flex-col md:flex-row w-full gap-4'>
            {/* Colonne de gauche */}
            <div className='w-full md:w-1/3 overflow-auto'>
              {/* Statistique globale */}
              <div className='mb-2 bg-yellow-50 flex justify-between items-center px-4 py-2'>
                <span className='font-bold text-lg'>Global</span>
                <span>
                  Total
                  {' '}
                  <b>{globalStats?.totalCount}</b>
                  {globalStats?.totalAmount > 0 && (
                  <>
                    {' '}
                    |
                    {' '}
                    <b>{globalStats?.totalAmount}</b>
                    {' '}
                    Ar
                  </>
                  )}
                </span>
              </div>

              {yearsFromResponse.map((year) => {
                const yearStat = statsByYear.find((s) => s._id === year);

                return (
                  <Card key={year} size='small' className='mb-2'>
                    <div
                      className='cursor-pointer font-bold text-lg flex justify-between'
                      onClick={() => toggleYear(year)}
                    >
                      <span>{year}</span>
                      {yearStat && (
                      <span className='text-sm font-normal text-gray-600'>
                        {`Total: ${yearStat.totalCount} | ${yearStat.totalAmount} Ar`}
                      </span>
                      )}
                    </div>
                    {activeYears.includes(year) && (
                    <>
                      <Divider className='my-2' />
                      <List
                        dataSource={months}
                        renderItem={(month, index) => {
                          const contribution = contributions.find(
                            (c) => c.year === year && c.month === index + 1
                          );
                          return (
                            <List.Item
                              className={`cursor-pointer flex justify-between items-center ${
                                selectedDate.year() === year &&
                              selectedDate.month() === index ?
                                  'bg--100' :
                                  ''
                              }`}
                              onClick={() => setSelectedDate(dayjs().year(year).month(index).date(1))}
                            >
                              <span>{month}</span>
                              {contribution && (
                              <span className='flex items-center'>
                                <span className='text-gray-400 mr-2'>
                                  {dayjs(contribution?.createdAt).format('DD MMMM')}
                                </span>
                                <span className='mr-2'>
                                  {contribution.amount}
                                  {' '}
                                  Ar
                                </span>
                                {contribution.status === 'paid' && (
                                <Tag color='#87d068'>Payé</Tag>
                                )}
                              </span>
                              )}
                            </List.Item>
                          );
                        }}
                      />
                    </>
                    )}
                  </Card>
                );
              })}
            </div>

            {/* Colonne de droite */}
            <div className='flex-1 w-full'>
              <ScheduleXCalendar calendarApp={calendar} />
            </div>
          </div>
        )}
      </Skeleton>
    </div>

  );
}

export default UserData;
